// Conexão com provedor de ligação: Cloud API e, em teste, Baileys com
// REACT_APP_BAILEYS_CALLS. Espelho do getCallProvider do backend
// (backend/src/services/CallServices/providers), que decide de verdade.
export const isCallableWhatsapp = (whatsapp) =>
  whatsapp?.type === "cloudapi" ||
  (whatsapp?.type === "baileys" && process.env.REACT_APP_BAILEYS_CALLS === "true");
